import { CheckOutlined } from "@ant-design/icons"
import { Button, Card, DatePicker, Flex } from "antd"
import dayjs from "dayjs"
import { usePrivateInvestmentsReports } from "../../../hooks/templates/private-investments/usePrivateInvestmentsReports"
import { borders, spaces } from "../../../utils/styles"

export const Reports = () => {
  const { date, setDate, update } = usePrivateInvestmentsReports()

  const disabledDate = (current) => current && current > dayjs().endOf("month")

  return (
    <Flex style={{ padding: spaces.space2, gap: spaces.space2, flexDirection: "column", alignItems: "center" }}>
      <iframe
        title="Relatórios Ilíquidos"
        style={{ width: "97vw", border: borders.default, borderRadius: 8 }}
        height="541.25"
        src="https://app.powerbi.com/reportEmbed?reportId=97fd6cf7-f7b5-4208-82f2-f44d9a368b85&autoAuth=true&ctid=24811785-2d33-4fa5-8fbb-416f50a0fbca"
      />
      <Card
        style={{ width: 420 }}
        styles={{ body: { display: "flex", flexDirection: "column", gap: spaces.space1 } }}
        title="Force update"
        size="small"
      >
        <p style={{ textAlign: "center" }}>
          Choose a month to refresh the report. This process will update transactions, recalculate metrics and join the benchmarks.
        </p>
        <DatePicker.MonthPicker value={date} onChange={setDate} style={{ width: "100%" }} disabledDate={disabledDate} />
        <Button type="primary" icon={<CheckOutlined />} onClick={update}>
          OK
        </Button>
      </Card>
    </Flex>
  )
}
